import { forwardRef, useImperativeHandle } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './joinWTNBanner.module.scss'
import { JoinWTNBannerRef } from '../types'
import registrationApi from 'api/rest/registration'
import { ReactComponent as ArrowRightIcon } from '../../../images/icons/icn-arrow-right.svg'
import useElement from 'hooks/use-element'

interface JoinWTNBannerProps {
  bannerText: string
}

const JoinWTNBanner = forwardRef<JoinWTNBannerRef, JoinWTNBannerProps>((props, ref) => {
  const { t } = useTranslation(['strCommonUI'])
  const { bannerText } = props
  const [element, bannerRef] = useElement<HTMLDivElement>()

  useImperativeHandle(ref, () => ({
    getElement: () => element,
  }))

  const handleBannerClick = (e: React.MouseEvent) => {
    e.preventDefault()
    registrationApi.redirectToRegister({ enableLogging: true })
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      registrationApi.redirectToRegister({ enableLogging: true })
    }
  }

  return (
    <div
      ref={bannerRef}
      className={styles.joinBanner}
      data-testid='join-wtn-banner'
      onClick={handleBannerClick}
      onKeyDown={handleKeyDown}
      role='button'
      tabIndex={0}
      aria-label={t('ariaLabel.joinWtn', 'Join WTN')}
    >
      <span className={styles.bannerText}>{bannerText}</span>
      <ArrowRightIcon className={styles.bannerArrow} />
    </div>
  )
})

export default JoinWTNBanner
